export default class Step1Manager {
    initialize() {
        this.eventDelegation();
        this.setAffixCriteria();
        this.setCachedValues();
        this.setSimilarChollosByNightsValues();
        this.displayNightsAlert();
    }

    eventDelegation() {
        $(window).on("scroll", () => {
            this.setAffixCriteria();
        });
    }

    setAffixCriteria() {
        let affixHeaderContainer = $('[data-entity="affix-header-container"]')

        let scrollTop = $(window).scrollTop() + 17;
        let offsetTop = $('#date-selector').offset().top;
        let height = $('#date-selector').height();
        if (scrollTop > offsetTop && scrollTop < (offsetTop + height)) {
            affixHeaderContainer.height($('[data-entity=affix-header]').height());
            $('[data-entity=affix-header]').addClass('affix');
        } else {
            $('[data-entity=affix-header]').removeClass('affix');
            affixHeaderContainer.height('');
        }
    }


    setCachedValues() {
        let loadSearchParameters = $('[data-load-search-parameters]');

        if ((loadSearchParameters.length === 0 || (loadSearchParameters.length > 0 && loadSearchParameters.val())) && myApp.browserStorageService.getBrowserStorageAvailable()) {
            var adults = localStorage.getItem('adults');
            var children = localStorage.getItem('children');
            var rooms = localStorage.getItem('rooms');
            var start = localStorage.getItem('start');
            var end = localStorage.getItem('end');
            var childrenAges = localStorage.getItem('childrenAges');

            if (adults && !isNaN(parseInt(adults))) {
                $("[data-input-sibling=adults] option:selected").removeAttr('selected');
                $('[data-input-sibling=adults]').val(adults);
                $("[data-input-sibling=adults] option[value=" + adults + "]").attr('selected', '');
                $('[data-input-sibling=adults]').parents('[data-input-container]').show();
                $('[data-input-sibling=adults]').change();
            }
            if (children && !isNaN(parseInt(children))) {
                $("[data-input-sibling=children] option:selected").removeAttr('selected');
                $('[data-input-sibling=children]').val(children);
                $("[data-input-sibling=children] option[value=" + children + "]").attr('selected', '');
                $('[data-input-sibling=children]').parents('[data-input-container]').show();
                $('[data-input-sibling=children]').change();
            }
            if (rooms) {
                $("[data-input-sibling=rooms] option:selected").removeAttr('selected');
                $('[data-input-sibling=rooms]').val(rooms);
                $("[data-input-sibling=rooms] option[value=" + rooms + "]").attr('selected', '');
                $('[data-input-sibling=rooms]').parents('[data-input-container]').show();
                $('[data-input-sibling=rooms]').change();
            }
            if (start && end) {
                let startDateArray = start.split("-");
                let endDateArray = end.split("-");
                let nowDate = (new Date()).setHours(0, 0, 0, 0,);

                if((new Date(startDateArray[2], startDateArray[1]-1, startDateArray[0]).getTime() >= nowDate) &&
                    new Date(endDateArray[2], endDateArray[1]-1, endDateArray[0]).getTime() >= nowDate) {
                    $('[data-input-sibling=start]').val(start);
                    $('[data-input-sibling=end]').val(end);
                }
            }
            if (adults || children) {
                $('[data-input-sibling=people]').parents('[data-input-container]').hide();
                $('[data-button-searcher]').addClass('col-xs-offset-3');
            }
            if (childrenAges) {
                var arrayAges = childrenAges.split(';');
                $.each(arrayAges, function (index, age) {
                    if(isNaN(parseInt(age))) {
                        return true;
                    }
                    if (index >= children){
                        return false;
                    }
                    $('[data-input-sibling=children_age_' + (index + 1) + ']').val(age);
                    $('[data-input-sibling=children_age_' + (index + 1) + '] option[value=' + age + ']').attr('selected', '');
                    $('[data-input-sibling=children_age_' + (index + 1) + ']').change();
                });
            }
        }
    }

    setSimilarChollosByNightsValues() {
        const nightsSelector = document.getElementById('night-selector');

        if (!nightsSelector) return;

        nightsSelector.addEventListener("change", (e) => {
            document.location.href = e.currentTarget.value + "?nightsChanged";
        })
    }

    displayNightsAlert() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const alertElement = document.getElementById('night-alert');

        if (alertElement) {
            if (urlParams.has("nightsChanged")) {
                alertElement.classList.remove('hidden');
                urlParams.delete("nightsChanged");
                window.history.replaceState({}, '', '?' + urlParams.toString());
            } else {
                alertElement.classList.add('hidden');
            }
        }
    }
}
